import resolveGstRates from "./gstRates";

/** Billed line total: prefer `amount` (billedInvs), else legacy `specialRate`. */
const getLineAmount = (item) =>
  Number(item?.amount) || 0;

/**
 * @param rootCharges Optional invoice-root printing/mounting for INV (not per line).
 * @param taxRates Saved invoice { IGST, SGST, CGST } percentages.
 */
const getGstPerInventory = (
  gstNumber,
  inventories,
  HSN,
  type,
  rootCharges,
  taxRates
) => {

  // console.log("inventories::::::", inventories);
  const { igstRate, cgstRate, sgstRate, totalRate } = resolveGstRates(
    gstNumber,
    taxRates
  );
  const gstRate = totalRate;
  const hsnCd = HSN ? HSN : "998361";

  const buildLine = (rate, slNo, prdDesc = null) => {
    const r = Number(rate) || 0;
    const igstValue = (r * igstRate) / 100;
    const cgstValue = (r * cgstRate) / 100;
    const sgstValue = (r * sgstRate) / 100;
    return {
      SlNo: slNo,
      PrdDesc: prdDesc,
      IsServc: "Y",
      HsnCd: hsnCd,
      Qty: 1,
      Unit: "OTH",
      UnitPrice: r,
      TotAmt: r,
      Discount: 0,
      PreTaxVal: 0,
      AssAmt: r,
      GstRt: gstRate,
      IgstAmt: igstValue,
      CgstAmt: cgstValue,
      SgstAmt: sgstValue,
      CesRt: 0,
      CesAmt: 0,
      CesNonAdvlAmt: 0,
      StateCesRt: 0,
      StateCesAmt: 0,
      StateCesNonAdvlAmt: 0,
      OthChrg: 0,
      TotItemVal: r + igstValue + cgstValue + sgstValue,
    };
  };

  // Credit note: keep one object per inventory line
  if (type === "CRN" && inventories && typeof inventories === "object" && inventories.totalAmount !== undefined) {
    // inventories is infoForCN object
    const totalAmount = Number(inventories.totalAmount) || 0;
    const printingCharge = Number(inventories.printingCharge) || 0;
    const mountingCharge = Number(inventories.mountingCharge) || 0;
    const result = [
      buildLine(totalAmount, 1, null),
      buildLine(printingCharge + mountingCharge, 2, null)
    ];
    return result;
  }
  if (type === "CRN") {
    // fallback: inventories is array
    const result = (inventories || []).map((item, index) => {
      const rate = Number(item.creditNoteAmount) || 0;
      return buildLine(rate, index + 1);
    });
    return result;
  }

  // Invoice: at most 2 lines — (1) sum line amounts (billedInvs.amount) (2) root printing+mounting
  const list = inventories || [];
  const sumLineAmount = list.reduce((acc, item) => acc + getLineAmount(item), 0);
  const sumPrintingMounting =
    (Number(rootCharges?.printingCharge) || 0) +
    (Number(rootCharges?.mountingCharge) || 0);

  const result = [];
  let slNo = 1;

  if (sumLineAmount > 0) {
    result.push(buildLine(sumLineAmount, slNo, null));
    slNo += 1;
  }

  if (sumPrintingMounting > 0) {
    result.push(buildLine(sumPrintingMounting, slNo, null));
  }

  // Fallback: inventories exist but both sums 0 — single zero line to avoid empty ItemList
  if (result.length === 0 && list.length > 0) {
    result.push(buildLine(0, 1, null));
  }

  // console.log("Oy 2 INV aggregated", result);
  return result;
};

export default getGstPerInventory;
